import { bl_fi_mst_entity_vehicle_model_variant_RowClass } from '../../../dbschema/bl_fi_mst_entity_vehicle_model_variant.model';
import {BaseContainerModel} from '../../base-container.model';


export class VehicleModelVariantContainerModel extends BaseContainerModel {
bl_fi_mst_entity_vehicle_model_variant: bl_fi_mst_entity_vehicle_model_variant_RowClass = new bl_fi_mst_entity_vehicle_model_variant_RowClass();
}
